export const formatCreditCardDate = (value: string): string => {
  let formatedDate = value;
  if (new RegExp('^[0-9/]*$').test(value)) {
    if (value.length >= 4 && value.indexOf('/') === -1) {
      formatedDate = `${value.slice(0, 2)}/${value.slice(2, 4)}`;
    }
  } else {
    formatedDate = '';
  }
  return formatedDate;
};

export const isAmericanExpressCard = (
  cardNumber: string | undefined,
): boolean => {
  if (!cardNumber) return true;
  return new RegExp('^3[47][0-9]{13}$').test(cardNumber);
};
